export let options = {
  apiURL: "https://api.1000x.ch/api",
  blockchainID: 1,
  swapID: 2,
  thousandXSWAPAddress: "0x44CbEff7F888C8d7eB8fed57E734e15d6bF4878d",
};
